/**
 * 用户接口
 *
 * @author 张子超
 * @since 2018-04-04
 */
import common from "./common";
import store from "./store";
import router from "../router";

var ApiList = {};

//API 接口

// ApiList.getInfo = function(okCb, failCb){
//     common.Send('/service/user/info.json').then((res) => {
//         console.log(res);
//         var body = res.body;
//         if(body.status == store.Codes.NotLogin){
//             if(location.href.startsWith('http://localhost') || location.href.startsWith('http://127.0.0.1')){
//                 location.href = `${common.apiHost}/.dev/login?userId=${common.testUserId}`;
//             }else{
//                 location.href = `${common.apiHost}/wx/auth?type=${body.data.type}&page=${location.href}`;
//             }
//             return;
//         }else{
//             okCb(body.data.user);
//         }
//     })
//     .catch((res)=>{
//         failCb(res.body);
//     });
// }

var loginFail = (body, failCb) => {
  if (body.status == store.Codes.NotLogin) {
    //未登录
    if (
      location.href.startsWith("http://localhost") ||
      location.href.startsWith("http://127.0.0.1")
    ) {
      location.href = `${common.devLogin}`;
    } else if (location.href.startsWith("http://gmall.test.")) {
      //测试环境
      // location.href = `${common.devLogin}`;
      failCb(body);
    } else {
      //正式环境
      failCb(body);
    }
    return;
  }
  failCb(body);
};

/**
 * 创建厂商/更新厂商信息
 *
 */
ApiList.getInfo = function(okCb, failCb) {
  var p = {};
  failCb = failCb || common.EmptyFn;
  common.ApiWithCache(
    "/customer/api/getUserInfo.json",
    p,
    (body) => {
      okCb(body);
    },
    (body) => {
      loginFail(body, failCb);
    }
  );
};

/**
 * 创建厂商/更新厂商信息
 *
 */
ApiList.getAndUpdateInfo = function(okCb, failCb) {
  ApiList.getInfo((user) => {
    store.loginedUser = user;
  }, failCb);
};

/**
 * 获取当前登录用户的个人信息
 * @param {*} okCb
 * @param {*} failCb
 */
ApiList.getPersonalInfo = function(okCb, failCb) {
  var p = {};
  failCb = failCb || common.EmptyFn;
  common.Api(
    "/customer/api/getUserInfo.json",
    p,
    (body) => {
      store.loginedUser = body;
      okCb(body);
    },
    (body) => {
      loginFail(body, failCb);
    }
  );
};

/**
 * 获取分享回跳链接
 * @param {*} pageUrl
 * @param {*} token
 * @param {*} okCb
 * @param {*} failCb
 */
ApiList.getShareBackUrl = function(pageUrl, token, okCb, failCb) {
  var p = {
    pageUrl,
    token,
  };
  common.Api("/customer/api/getShareBackUrl.json", p, okCb, failCb);
};

/**
 * 修改当前登录用户的个人信息
 * @param {*} param
 * @param {*} okCb
 * @param {*} failCb
 */
ApiList.modifyPersonalInfo = function(param, okCb, failCb) {
  var p = {
    param,
  };
  common.Api("/service/user/modifyPersonalInfo.json", p, okCb, failCb);
};

/**
 * 获取分享参数
    /customer/api/getShareParam.json

    RequireLogin: true

    参数
        pageUrl: string - 分享的页面 url
    返回
        shareParam: object - 分享参数
        appId: string -
        errorMsg: string -
        nonceStr: string -
        signUrl: string -
        signature: string -
        status: string -
        timestamp: integer -
 * @param {*} param 
 * @param {*} okCb 
 * @param {*} failCb 
 */
ApiList.getShareParam = function(pageUrl, okCb, failCb) {
  var p = {
    pageUrl,
  };
  common.Api("/customer/api/getShareParam.json", p, okCb, failCb);
};

/**
 * 获取手机号列表
 * @param {*} param
 * @param {*} okCb
 * @param {*} failCb
 */
ApiList.userPhoneAddressList = function(okCb, failCb) {
  var p = {};
  common.Api("/customer/api/userPhoneAddress/list.json", p, okCb, failCb);
};

/**
 * 获取默认手机号
 * @param {*} param
 * @param {*} okCb
 * @param {*} failCb
 */
ApiList.userPhoneAddressDefault = function(okCb, failCb) {
  var p = {};
  common.Api("/customer/api/userPhoneAddress/default.json", p, okCb, failCb);
};

/**
 * 删除手机号
 * @param {*} param
 * @param {*} okCb
 * @param {*} failCb
 */
ApiList.userPhoneAddressDelete = function(id, okCb, failCb) {
  var p = {
    id,
  };
  common.Api("/customer/api/userPhoneAddress/delete.json", p, okCb, failCb);
};

/**
 * 获取图片验证
 * @param {*} param
 * @param {*} okCb
 * @param {*} failCb
 */
ApiList.userPhoneAddressCaptcha = function(okCb, failCb) {
  var p = {};
  common.Api("/customer/api/userPhoneAddress/captcha.json", p, okCb, failCb);
};

/**
 * 发送验证码短信
 * @param {*} param
 * @param {*} okCb
 * @param {*} failCb
 */
ApiList.userPhoneAddressSendVerifyCode = function(
  captchaCode,
  captchaId,
  phone,
  okCb,
  failCb
) {
  var p = {
    captchaCode,
    captchaId,
    phone,
  };
  common.Api(
    "/customer/api/userPhoneAddress/sendVerifyCode.json",
    p,
    okCb,
    failCb
  );
};

/**
 * 发送验证码短信
 * @param {*} param
 * @param {*} okCb
 * @param {*} failCb
 */
ApiList.userPhoneAddressBindPhone = function(code, phone, okCb, failCb) {
  var p = {
    code,
    phone,
  };
  common.Api("/customer/api/userPhoneAddress/bindPhone.json", p, okCb, failCb);
};

/**
 * 绑定手机号
 * @param {*} phone
 * @param {*} code
 * @param {*} okCb
 * @param {*} failCb
 */
ApiList.bindPhone = function(phone, code, okCb, failCb) {
  var p = {
    phone,
    code,
  };
  common.Api("/customer/api/user/bindPhone.json", p, okCb, failCb);
};

/**
 * 查看绑定手机设置
 * @param {*} captchaId
 * @param {*} captchaCode
 * @param {*} phone
 * @param {*} okCb
 * @param {*} failCb
 */
ApiList.getPhoneValidSetting = function(okCb, failCb) {
  var p = {};
  common.Api("/customer/api/user/phoneSetting.json", p, okCb, failCb);
};

/**
 * 绑定手机发送短信
 * @param {*} captchaId
 * @param {*} captchaCode
 * @param {*} phone
 * @param {*} okCb
 * @param {*} failCb
 */
ApiList.getPhoneValidSendVerifyCode = function(
  captchaId,
  captchaCode,
  phone,
  okCb,
  failCb
) {
  var p = {
    captchaId,
    captchaCode,
    phone,
  };
  common.Api("/customer/api/user/sendVerifyCode.json", p, okCb, failCb);
};

/**
 * 用户绑定手机获取图片验证码
 * @param {*} okCb
 * @param {*} failCb
 */
ApiList.getPhoneValidCaptcha = function(okCb, failCb) {
  var p = {};
  common.Api("/customer/api/user/captcha.json", p, okCb, failCb);
};

//API 其他逻辑

// if(!store.loginedUser){
//     ApiList.getInfo(
//         user => {
//             store.loginedUser = user;
//         },
//         ()=>{
//             alert('无法登录，请刷新重试');
//         });
// }

export default ApiList;



// WEBPACK FOOTER //
// ./src/api/user-api.js